import { useState, useMemo } from "react";
import { IDriverMember } from "../components/card/card";

type FilterType = "all" | "on-shift" | "on-break";

interface UseDriverFiltersResult {
  filter: FilterType;
  setFilter: (filter: FilterType) => void;
  roleFilter: string;
  setRoleFilter: (role: string) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  filteredDrivers: IDriverMember[];
}

export const useDriverFilters = (drivers: IDriverMember[]): UseDriverFiltersResult => {
  const [filter, setFilter] = useState<FilterType>("on-shift");
  const [roleFilter, setRoleFilter] = useState<string>("all");
  const [searchQuery, setSearchQuery] = useState<string>("");

  const filteredDrivers = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();

    return drivers.filter((driver) => {
      // Status filter
      if (filter !== "all" && driver.status !== filter) {
        return false;
      }

      // Role filter
      if (roleFilter !== "all" && driver.assignment !== roleFilter) {
        return false;
      }

      //Search filter
      if (query && !driver.name.toLowerCase().includes(query)) {
        return false;
      }

      return true;
    });
  }, [drivers, filter, roleFilter, searchQuery]);

  return {
    filter,
    setFilter,
    roleFilter,
    setRoleFilter,
    searchQuery,
    setSearchQuery,
    filteredDrivers,
  };
};
